import React from 'react';
import {
  WMSTileLayer,
} from 'react-leaflet';

const initPathWMS = process.env.REACT_APP_WMS;

export default function WmsBoundary() {
  return (
    <WMSTileLayer
      url={`${initPathWMS}wms`}
      version="1.1.0"
      opacity={1}
      transparent
      layers="thailand_boundary"
      srs="EPSG:4326"
      format="image/png"
      tiled
    />
  );
}
